<mat-expansion-panel
  [expanded]="expanded()"
  (expandedChange)="setExpanded($event)"
  class="solver-panel mat-elevation-z0"
>
  <mat-expansion-panel-header class="solver-header">
    <mat-panel-title>
      <div class="flex w-full flex-col gap-2">
        @if (solver().name) {
          <div class="text-xs font-bold uppercase text-sky-600">
            {{ solver().name }}
          </div>
        }
        <div class="stem-content">
          @for (item of solver().content; track item.id) {
            @if (item.type === ContentBlockType.Markdown) {
              <markdown
                katex
                [katexOptions]="katexOptions"
                class="font-normal text-neutral-800"
                [data]="item.markdown"
              ></markdown>
            }
            <!-- TODO: Support the other content block types -->
          }
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div class="slides-container">
      @for (slide of slidesViewModel(); track $index; let slideIndex = $index) {
        <div class="slide-group">
          <div class="slide-header">
            <div class="counter-badge">
              <span>{{ slideIndex + 1 }}</span>
            </div>
            <markdown
              katex
              [katexOptions]="katexOptions"
              class="slide-title"
              [data]="slide.name || slide.steps[getCurrentStepIndex(slideIndex)].title"
            ></markdown>
          </div>

          @if (slide.layout?.type === 'simple') {
            <dojo-simple-solver
              [slide]="slide"
              [config]="{ maxWidth: getSimpleConfig(slide.layout)?.maxWidth, resizable: false }"
            />
          } @else {
            <div class="step-card">
              <div
                class="carousel-container w-full"
                (touchstart)="onTouchStart($event)"
                (touchend)="onTouchEnd($event, slideIndex, slide.steps.length)"
              >
                <div class="carousel-content">
                  <div class="latex-section">
                    <dojo-super-latex [content]="slide.steps[getCurrentStepIndex(slideIndex)].computedContent" />
                  </div>

                  @for (item of slide.steps[getCurrentStepIndex(slideIndex)].computedDescription; track item.id) {
                    @if (item.type === ContentBlockType.Markdown) {
                      <div class="description" @itemStaggerAnimation>
                        <markdown
                          katex
                          [katexOptions]="katexOptions"
                          class="font-normal text-neutral-800"
                          [data]="item.markdown"
                        ></markdown>
                      </div>
                    }
                  }
                </div>

                @if (slide.steps.length > 1) {
                  <div class="carousel-actions">
                    <div class="navigation-buttons">
                      <dojo-button
                        (click)="goToPreviousStep(slideIndex)"
                        [disabled]="getCurrentStepIndex(slideIndex) === 0"
                        [fill]="'outline'"
                        size="s"
                      >
                        <dojo-icon [class.text-sky-500]="getCurrentStepIndex(slideIndex) !== 0" [icon]="'angle-left'" />
                      </dojo-button>

                      <dojo-button
                        [fill]="'outline'"
                        (click)="goToNextStep(slideIndex, slide.steps.length)"
                        [disabled]="getCurrentStepIndex(slideIndex) === slide.steps.length - 1"
                        size="s"
                      >
                        <dojo-icon
                          [class.text-sky-500]="getCurrentStepIndex(slideIndex) !== slide.steps.length - 1"
                          [icon]="'angle-right'"
                        />
                      </dojo-button>
                    </div>
                    <span class="slider-numbers text-disabled adjusted-numbers ml-auto text-xs font-semibold">
                      {{ getCurrentStepIndex(slideIndex) + 1 }}/{{ slide.steps.length }}
                    </span>
                  </div>

                  <!--                <div class="mobile-pagination">-->
                  <!--                  @for (step of slide.steps; track step; let i = $index) {-->
                  <!--                    <div class="dot" [class.active]="getCurrentStepIndex(slideIndex) === i"></div>-->
                  <!--                  }-->
                  <!--                </div>-->
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</mat-expansion-panel>
